import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  SelectField as MuiSelectField,
  MenuItem as MuiMenuItem,
  TextField as MuiTextField,
} from 'material-ui';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { blueGray, solidWhite, white30 } from '../../../theme/colors';
import globalStyles from '../../../shared-styles';

class WeightSelect extends Component {
  static propTypes = {
    unitSystem: PropTypes.string,
    displayWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setWeight: PropTypes.func,
    resetWeight: PropTypes.func,
    setUnitSystem: PropTypes.func
  };

  verifyWeight = () => {
    const value = this.props.displayWeight;

    let min;
    let max;
    if (this.props.unitSystem === 'metric') {
      min = 30;
      max = 205;
    } else {
      min = 70;
      max = 450;
    }
    if (!value || value < min) {
      this.props.setWeight({}, min);
    } else if (value > max) {
      this.props.setWeight({}, max);
    }
  }

  render() {
    return (
      <div className="weight-select">
        <Grid fluid>
          <Row className="weight-select-row">
            <Col xs={ 6 }>
              <MuiTextField
                pattern="[0-9]*"
                type="text"
                hintText="Weight"
                className="weight-select-input weight-select-text"
                value={ this.props.displayWeight }
                onBlur={ this.verifyWeight }
                onChange={ this.props.setWeight }
                onFocus={ this.props.resetWeight }
                inputStyle={{ color: solidWhite }}
                hintStyle={{ color: white30 }}
                fullWidth
                underlineShow={ false }
                autoCapitalize="off"
                autoCorrect="off"
              />
            </Col>
            <Col xs={ 6 }>
              <MuiSelectField
                className="weight-select-input user-profile-select-input"
                value={ this.props.unitSystem }
                autoWidth={ true }
                fullWidth={ true }
                onChange={ this.props.setUnitSystem }
                iconStyle={{ display: 'none' }}
                labelStyle={{ ...globalStyles.selectLabelStyle, color: solidWhite }}
                hintStyle={ globalStyles.selectHintStyle }
                selectedMenuItemStyle={{
                  color: blueGray,
                  fontWeight: 600
                }}
                dropDownMenuProps={{
                  targetOrigin: {
                    vertical: 'center',
                    horizontal: 'left'
                  }
                }}
                maxHeight={ 400 }
              >
                <MuiMenuItem primaryText="kg" value="metric" />
                <MuiMenuItem primaryText="lbs" value="standard" />
              </MuiSelectField>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default WeightSelect;
